import { createResponseSchema } from '@mint-sdk/api-core';
import { z } from 'zod';

import { GroupingLevelsEnum } from './taxonomy.js';

export const GroupingBodySchema = z.object({
  level: z.string(),
});

export const GroupingRulesResponseDeprecatedSchema = createResponseSchema(
  z.object({
    grouping: z.object({
      id: z.string(),
      channel: z.string(),
      platform: z.string(),
      level: GroupingLevelsEnum,
    }),
    clearedRules: z.array(z.string()),
  }),
);

export const GroupingRulesSchema = z.object({
  grouping: z.object({
    id: z.string(),
    channel: z.string().nullable(),
    platform: z.string(),
    level: GroupingLevelsEnum,
  }),
  clearedRules: z.array(z.string()),
});

export const GroupingRulesResponseSchema =
  createResponseSchema(GroupingRulesSchema);

export const GroupingUpdatedMessageSchema = z.object({
  id: z.string(),
  platformId: z.string(),
  platform: z.string(),
  level: GroupingLevelsEnum,
});

export type GroupingRulesResponseType = z.infer<
  typeof GroupingUpdatedMessageSchema
>;
